module.exports = __webpack_public_path__ + "static/img/about_bg_01.3b3013c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/about_bg_01.png
// module id = qyAt
// module chunks = 34